/**
 * Botaniche — Main JavaScript
 * Handles: Cart AJAX, Header behavior, Quantity selectors, Tabs, Accordion
 */
(function() {
  'use strict';

  // ═══════════════════════════════════════════
  // QUANTITY SELECTORS
  // ═══════════════════════════════════════════
  function initQuantitySelectors() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      const input = selector.querySelector('.quantity-selector__input');
      const minusBtn = selector.querySelector('[data-quantity-minus]');
      const plusBtn = selector.querySelector('[data-quantity-plus]');
      if (!input) return;

      minusBtn && minusBtn.addEventListener('click', function() {
        const current = parseInt(input.value) || 1;
        const min = parseInt(input.getAttribute('min')) || 1;
        if (current > min) {
          input.value = current - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      plusBtn && plusBtn.addEventListener('click', function() {
        const current = parseInt(input.value) || 1;
        const max = parseInt(input.getAttribute('max')) || 99;
        if (current < max) {
          input.value = current + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // ═══════════════════════════════════════════
  // ADD TO CART — AJAX
  // ═══════════════════════════════════════════
  function initAddToCart() {
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      e.preventDefault();
      const variantId = btn.getAttribute('data-add-to-cart');

      // Find quantity input
      let quantity = 1;
      const qtyInput = document.querySelector('.quantity-selector__input');
      if (qtyInput) {
        quantity = parseInt(qtyInput.value) || 1;
      }

      // Also try product form
      const form = btn.closest('form');
      let formData;

      if (form) {
        formData = new FormData(form);
      } else {
        formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        // Add sections for cart drawer update
        formData.append('sections', 'cart-drawer');
      }

      btn.classList.add('btn--loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(function(data) {
        // Update cart count
        updateCartCount(data);

        // Show toast
        showToast('Added to cart! ✓', 'success');

        // Bump cart icon
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          countEl.classList.add('header__cart-count--bump');
          setTimeout(function() { countEl.classList.remove('header__cart-count--bump'); }, 300);
        }

        // Refresh cart drawer if open
        refreshCartDrawer();
      })
      .catch(function(error) {
        console.error('Add to cart error:', error);
        showToast('Something went wrong. Please try again.', 'error');
      })
      .finally(function() {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      });
    });
  }

  function updateCartCount(data) {
    // Fetch actual cart to get correct count
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        const countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        const countDrawer = document.querySelector('[data-cart-count-drawer]');
        if (countDrawer) {
          countDrawer.textContent = '(' + cart.item_count + ')';
        }
      });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function(res) { return res.text(); })
      .then(function(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('.cart-drawer');
        const currentDrawer = document.querySelector('.cart-drawer');
        if (newDrawer && currentDrawer) {
          // Update items and footer
          const newItems = newDrawer.querySelector('[data-cart-items]');
          const currentItems = currentDrawer.querySelector('[data-cart-items]');
          const newFooter = newDrawer.querySelector('.cart-drawer__footer');
          const currentFooter = currentDrawer.querySelector('.cart-drawer__footer');

          if (newItems && currentItems) {
            currentItems.innerHTML = newItems.innerHTML;
          }
          if (newFooter && currentFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          } else if (newFooter && !currentFooter) {
            currentDrawer.appendChild(newFooter);
          }
        }
        initQuantitySelectors();
      });
  }

  // ═══════════════════════════════════════════
  // TOAST NOTIFICATIONS
  // ═══════════════════════════════════════════
  function showToast(message, type) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }

    toast.className = 'toast toast--' + (type || 'success');
    toast.textContent = message;
    toast.classList.add('toast--visible');

    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function() {
      toast.classList.remove('toast--visible');
    }, 3000);
  }

  // ═══════════════════════════════════════════
  // PRODUCT VARIANT SWATCHES
  // ═══════════════════════════════════════════
  function initVariantSwatches() {
    var swatchesContainer = document.querySelector('[data-variant-swatches]');
    if (!swatchesContainer) return;

    var variantDataEl = document.getElementById('variantData');
    if (!variantDataEl) return;

    var variantData;
    try {
      variantData = JSON.parse(variantDataEl.textContent);
    } catch(e) {
      return;
    }

    var variantInput = document.getElementById('productVariant');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var mainImg = document.getElementById('mainProductImage');
    var priceCurrent = document.querySelector('.price__current');
    var priceCompare = document.querySelector('.price__compare');
    var priceSave = document.querySelector('.price__save');
    var stockInfo = document.querySelector('.product-info__stock');

    // Init: just visually mark default swatches — Liquid already set correct button/price
    var defaultSwatches = swatchesContainer.querySelectorAll('[data-default-selected]');
    for (var i = 0; i < defaultSwatches.length; i++) {
      defaultSwatches[i].classList.add('variant-swatch--selected');
    }
    updateAllLabels();

    // Click handler
    swatchesContainer.addEventListener('click', function(e) {
      var swatch = e.target.closest('.variant-swatch');
      if (!swatch || swatch.classList.contains('variant-swatch--sold-out')) return;

      var optionName = swatch.getAttribute('data-option-name');

      // Deselect siblings in same group
      var group = swatchesContainer.querySelector('[data-option-group="' + optionName + '"]');
      if (group) {
        var siblings = group.querySelectorAll('.variant-swatch--selected');
        for (var s = 0; s < siblings.length; s++) {
          siblings[s].classList.remove('variant-swatch--selected');
        }
      }

      // Select clicked swatch
      swatch.classList.add('variant-swatch--selected');
      updateAllLabels();

      // Build option selection from ALL groups
      var selected = {};
      var allSelected = swatchesContainer.querySelectorAll('.variant-swatch--selected');
      for (var j = 0; j < allSelected.length; j++) {
        selected[allSelected[j].getAttribute('data-option-name')] = allSelected[j].getAttribute('data-option-value');
      }

      // Find matching variant
      var matchedId = null;
      for (var vid in variantData) {
        var v = variantData[vid];
        var ok = true;
        for (var opt in selected) {
          if (v.o[opt] !== selected[opt]) { ok = false; break; }
        }
        if (ok) { matchedId = vid; break; }
      }

      if (!matchedId) return;
      var d = variantData[matchedId];

      // Update hidden input
      if (variantInput) variantInput.value = matchedId;

      // Update button
      if (addBtn) {
        addBtn.setAttribute('data-add-to-cart', matchedId);
        addBtn.textContent = d.a ? '🛒 Add to Cart' : 'Sold Out';
        addBtn.disabled = !d.a;
        addBtn.style.opacity = d.a ? '1' : '0.6';
      }

      // Update price
      if (priceCurrent) priceCurrent.textContent = d.p;
      if (priceCompare) {
        priceCompare.textContent = d.c || '';
        priceCompare.style.display = d.c ? '' : 'none';
      }
      if (priceSave) {
        priceSave.style.display = d.c ? '' : 'none';
      }

      // Update image with crossfade
      if (mainImg && d.i) {
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = d.i;
          mainImg.style.opacity = '1';
        }, 100);
      }

      // Update stock
      if (stockInfo) {
        stockInfo.textContent = d.a ? '✓ In Stock — Ready to Ship' : '✕ Out of Stock';
        stockInfo.className = 'product-info__stock ' + (d.a ? 'product-info__stock--in' : 'product-info__stock--low');
      }

      // Update URL
      try {
        var url = new URL(window.location);
        url.searchParams.set('variant', matchedId);
        window.history.replaceState({}, '', url);
      } catch(_) {}
    });

    function updateAllLabels() {
      var labels = swatchesContainer.querySelectorAll('[data-option-label]');
      for (var k = 0; k < labels.length; k++) {
        labels[k].textContent = '';
        var sel = swatchesContainer.querySelector('[data-option-group="' + labels[k].getAttribute('data-option-label') + '"] .variant-swatch--selected');
        if (sel) {
          labels[k].textContent = sel.getAttribute('data-option-value').replace(/-/g, ' ');
        }
      }
    }
  }

  // ═══════════════════════════════════════════
  // PRODUCT IMAGE ZOOM
  // ═══════════════════════════════════════════
  function initImageZoom() {
    const mainGallery = document.querySelector('[data-main-gallery]');
    if (!mainGallery) return;
    const mainImg = mainGallery.querySelector('img');
    if (!mainImg) return;

    mainGallery.addEventListener('mousemove', function(e) {
      const rect = mainGallery.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      mainImg.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
    });

    mainGallery.addEventListener('mouseleave', function() {
      mainImg.style.transformOrigin = 'center center';
    });
  }

  // ═══════════════════════════════════════════
  // CART DRAWER QUANTITY UPDATE
  // ═══════════════════════════════════════════
  function initCartQuantityUpdate() {
    document.addEventListener('change', function(e) {
      const input = e.target.closest('[data-quantity-input]');
      if (!input) return;

      const line = input.getAttribute('data-line');
      const quantity = parseInt(input.value) || 0;

      if (quantity === 0) {
        // Remove item
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function() { refreshCartDrawer(); updateCartCount(); });
      } else {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        }).then(function() { refreshCartDrawer(); updateCartCount(); });
      }
    });
  }

  // ═══════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════
  function init() {
    initQuantitySelectors();
    initAddToCart();
    initVariantSwatches();
    initImageZoom();
    initCartQuantityUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
